import React from 'react';
import { FaFacebook } from 'react-icons/fa';
import styled, { css } from 'styled-components';

const glass = css`
  backdrop-filter: blur(26px) saturate(175%) brightness(1.03);
  -webkit-backdrop-filter: blur(26px) saturate(175%) brightness(1.03);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.04)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.55), rgba(255,255,255,0.18), rgba(139,29,29,0.16)) border-box;

  box-shadow:
    0 18px 55px rgba(0,0,0,0.12),
    inset 0 1px 0 rgba(255,255,255,0.35);
`;

const glassSoft = css`
  backdrop-filter: blur(18px) saturate(165%) brightness(1.02);
  -webkit-backdrop-filter: blur(18px) saturate(165%) brightness(1.02);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.03)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.45), rgba(255,255,255,0.16), rgba(139,29,29,0.14)) border-box;

  box-shadow:
    0 14px 45px rgba(0,0,0,0.10),
    inset 0 1px 0 rgba(255,255,255,0.28);
`;

const Footer = () => {
  return (
    <FooterWrap>
      <FooterContainer>
        {/* ✅ Single block centered */}
        <FooterContent>
          <Column>
            <Title>eBaybayMo</Title>
            <Text>
              A community-driven app that uses technology to bring Baybayin characters to life, connecting tattoo
              artists, t-shirt designers, scholars, and enthusiasts with the rich heritage of the Filipino script.
            </Text>
          </Column>
        </FooterContent>

        <SocialIconsContainer>
          <SocialIcon>
            <a href="https://web.facebook.com/eBaybayMo" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
          </SocialIcon>
      
        </SocialIconsContainer>

        <FooterBottom>
          <BottomText>&copy; 2025 eBaybayMo. All rights reserved.</BottomText>
         
        </FooterBottom>
      </FooterContainer>
    </FooterWrap>
  );
};

export default Footer;

/* =========================
   Styles
   ========================= */

const FooterWrap = styled.footer`
  * { -webkit-tap-highlight-color: transparent; }
  padding: 3.2rem 1rem 2.2rem;
  background: transparent;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 760px;
    height: 760px;
    left: -340px;
    bottom: -380px;
    background: radial-gradient(circle at 35% 35%, rgba(139,29,29,0.16), transparent 62%);
    filter: blur(80px);
    opacity: 0.9;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    width: 820px;
    height: 820px;
    right: -380px;
    top: -420px;
    background: radial-gradient(circle at 40% 40%, rgba(246,201,69,0.14), transparent 62%);
    filter: blur(90px);
    opacity: 0.9;
    pointer-events: none;
  }
`;

const FooterContainer = styled.div`
  ${glass}
  max-width: 9500px;
  margin: 0 auto;
  border-radius: 26px;
  padding: 2.2rem 1.6rem 1.4rem;
  color: rgba(32, 21, 21, 0.88);
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 1.6rem 1.1rem 1.2rem;
  }
`;

/* ✅ Center the single block */
const FooterContent = styled.div`
  display: flex;
  justify-content: center;  /* center horizontally */
  align-items: center;
  margin-bottom: 1.25rem;
`;

const Column = styled.div`
  ${glassSoft}
  border-radius: 18px;
  padding: 1rem 1rem 0.9rem;
  width: 100%;
  max-width: 980px;        /* keeps nice readable width */
  text-align: center;      /* center text */
`;

const Title = styled.h4`
  margin: 0 0 0.65rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 1000;
  font-size: 1.12rem;
  letter-spacing: -0.01em;
  color: rgba(139, 29, 29, 0.95);
`;

const Text = styled.p`
  margin: 0;
  line-height: 1.65;
  font-family: 'Poppins', sans-serif;
  font-size: 1.02rem;
  color: rgba(32, 21, 21, 0.74);
`;

const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.85rem;
  margin: 1.1rem 0 1.05rem;
`;

const SocialIcon = styled.div`
  ${glassSoft}
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;

  a {
    color: rgba(139, 29, 29, 0.92);
    font-size: 1.18rem;
    line-height: 0;
    transition: color 0.18s ease, transform 0.18s ease, filter 0.18s ease;
  }

  &:hover a {
    color: rgba(246, 201, 69, 0.98);
    transform: translateY(-1px);
    filter: drop-shadow(0 10px 20px rgba(0,0,0,0.12));
  }
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid rgba(32, 21, 21, 0.12);
  padding-top: 1rem;
  gap: 0.55rem;
`;

const BottomText = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  color: rgba(32, 21, 21, 0.70);
  text-align: center;
`;
